import modulosData from '@content/modulos.json'
import { MODULO_TOTAL_TOPICOS } from '@utils/constants.js'
import type { ModuloStatus } from '@hooks/useModulos.js'
import type { TopicoStatus } from '@hooks/useModuloDetail.js'
import type { TopicoProgresso } from '@services/db.js'
import type { ModuloChecklist, TopicoChecklistItem } from '@hooks/useChecklistGeral.js'

function getTopicoStatus(prog: TopicoProgresso | null): TopicoStatus {
  if (!prog) return 'nao-iniciado'
  if (prog.concluido) return 'concluido'
  const temProgresso = prog.percentualPratico > 0 || prog.checklistItems.some((c) => c.concluido)
  return temProgresso ? 'em-andamento' : 'nao-iniciado'
}

function getModuloStatus(concluidos: number, total: number, temProgresso: boolean): ModuloStatus {
  if (total > 0 && concluidos === total) return 'concluido'
  if (temProgresso || concluidos > 0) return 'em-andamento'
  return 'nao-iniciado'
}

export function buildModulosChecklist(progressoAll: TopicoProgresso[]): ModuloChecklist[] {
  const progressoMap = new Map(progressoAll.map((p) => [p.topicoId, p]))

  return modulosData.modulos.map((m) => {
    const topicos: TopicoChecklistItem[] = m.topicos.map((t) => ({
      id: t.id,
      slug: t.slug,
      titulo: t.titulo,
      ordem: t.ordem,
      moduloId: m.id,
      status: getTopicoStatus(progressoMap.get(t.id) ?? null),
    }))

    const concluidos = topicos.filter((t) => t.status === 'concluido').length
    const total = MODULO_TOTAL_TOPICOS[m.id] ?? topicos.length
    const pct = total > 0 ? Math.round((concluidos / total) * 100) : 0
    const temProgresso = progressoAll.some(
      (p) =>
        p.moduloId === m.id &&
        (p.percentualPratico > 0 || p.checklistItems.some((c) => c.concluido)),
    )

    return {
      id: m.id,
      slug: m.slug,
      titulo: m.titulo,
      icone: m.icone,
      ordem: m.ordem,
      pct,
      concluidos,
      total,
      status: getModuloStatus(concluidos, total, temProgresso),
      topicos,
    }
  })
}
